import Address from "./address";
import Autocomplete from "./autocomplete";
import BasicTimePicker from "./basic-time-picker";
import Bullet from "./bullet";
import Button from "./button";
import CareTeamProvider from "./care-team-provider";
import getCaseListItem from "./case-list-item";
import CaseListItemAppoitments from "./case-list-item-appoitments";
import CellWithCheck from "./cell-with-check";
import Select from "./select";
import Slider from "./slider";
import Switch from "./switch";
import Checkbox from "./checkbox";
import Chip from "./chip";
import Container from "./container";
import CreditCardLogo from "./credit-card-logo";
import DatePicker from "./date-picker";
import {
  DialogOverlay,
  DialogSubHeader,
  DialogHeader,
  DialogHeaderContainer,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogCloseButton
} from "./dialog-parts";
import Dot from "./dot";
import ExpandoOption from "./expando-option";
import ExpansionMessage from "./expansion-message";
import ExpansionPanel from "./expansion-panel";
import FieldWrapper from "./field-wrapper";
import GMap from "./g-map";
import Goal from "./goal";
import HorizontalRule from "./horizontal-rule";
import HtmlText from "./html-text";
import Icon from "./icon";
import Image from "./image";
import WebImage from "./web-image";
import Input from "./input";
import Label from "./label";
import Link from "./link";
import ListItem from "./list-item";
import Loader from "./loader";
import LoaderInDialog from "./loader-in-dialog";
import MailOrderPharmacyAddress from "./mail-order-pharmacy-address";
import MemberAttachment from "./member-attachment";
import MessageHeader from "./message-header";
import PhoneLink from "./phone-link";
import PhotoPreviewButton from "./photo-preview-button";
import PieChart from "./pieChart";
import Pills from "./pills";
import ProgressBar from "./progress-bar";
import Provider from "./provider";
import Radio from "./radio";
import Screen from "./screen";
import Tabs from "./tabs";
import TaskList from "./task-list";
import Text from "./text";
import TextArea from "./text-area";
import TextField from "./text-field";
import TimePicker from "./time-picker";
import TimeSlotPicker from "./time-slot-picker";
import Title from "./title";
import Description from "./description";
import { ToastBody, ToastCloseButton, ToastContainer } from "./toast-parts";
import Tooltip from "./tooltip";
import Spinner from "./spinner";
import SelectWithChips from "./select-with-chips";
import PhonePicker from "./phone-picker";

// Modernized components
import {
  ModernizedModalOverlay,
  ModernizedModalBody,
  ModernizedModalHeaderContainer,
  ModernizedModalHeader,
  ModernizedModalContent,
  ModernizedModalFooter,
  ModernizedDismissibleButton
} from "./modernized/modernized-modal-parts";
import ModernizedInlineMessage from "./modernized/modernized-inline-message";
import ModernizedInputField from "./modernized/modernized-input-field";
import ModernizedLabel from "./modernized/modernized-label";
import ModernizedToggle from "./modernized/modernized-toggle";
import ModernizedAccordion from "./modernized/modernized-accordion";
import ModernizedPhoneInput from "./modernized/modernized-phone-input";
import ModernizedIconButton from "./modernized/modernized-icon-button";
/**
 * exports all of the available components as a single object default themes
 * @module theme/default
 * @exports Address
 * @exports Autocomplete
 * @exports BasicTimePicker
 * @exports Bullet
 * @exports Button
 * @exports CareTeamProvider
 * @exports getCaseListItem
 * @exports CellWithCheck
 * @exports Checkbox
 * @exports Chip
 * @exports CreditCardLogo
 * @exports DatePicker
 * @exports DialogBody
 * @exports DialogCloseButton
 * @exports DialogContent,
 * @exports DialogFooter
 * @exports DialogHeader
 * @exports DialogHeaderContainer
 * @exports DialogOverlay
 * @exports DialogSubHeader
 * @exports Dot
 * @exports ExpandoOption
 * @exports ExpansionMessage
 * @exports ExpansionPanel
 * @exports FieldWrapper
 * @exports GMap
 * @exports Goal
 * @exports HorizontalRule
 * @exports HtmlText
 * @exports Icon
 * @exports Image
 * @exports Input
 * @exports Label
 * @exports Link
 * @exports ListItem
 * @exports Loader
 * @exports LoaderInDialog
 * @exports MailOrderPharmacyAddress
 * @exports MemberAttachment
 * @exports MessageHeader
 * @exports PhoneLink
 * @exports PhotoPreviewButton
 * @exports PieChart
 * @exports Pills
 * @exports ProgressBar
 * @exports Provider
 * @exports Radio
 * @exports Screen
 * @exports Select
 * @exports Slider
 * @exports Switch
 * @exports Tabs
 * @exports TaskList
 * @exports Text
 * @exports TextArea
 * @exports TextField
 * @exports TimePicker
 * @exports TimeSlotPicker
 * @exports Title
 * @exports ToastBody
 * @exports ToastCloseButton
 * @exports ToastContainer
 * @exports Tooltip
 * @exports SelectWithChips
 *
 * ***** modernized *****
 * @exports ModernizedModalOverlay,
 * @exports ModernizedModalBody,
 * @exports ModernizedModalHeaderContainer,
 * @exports ModernizedModalHeader,
 * @exports ModernizedModalContent,
 * @exports ModernizedModalFooter
 * @exports ModernizedDismissibleButton,
 * @exports ModernizedInlineMessage
 * @exports ModernizedInputField
 * @exports ModernizedLabel
 * @exports ModernizedPhoneInput
 * @exports ModernizedToggle
 * @exports ModernizedAccordion
 * @exports ModernizedIconButton
 */
export default {
  Address,
  Autocomplete,
  BasicTimePicker,
  Bullet,
  Button,
  CareTeamProvider,
  getCaseListItem,
  CaseListItemAppoitments,
  CellWithCheck,
  Checkbox,
  Chip,
  Container,
  CreditCardLogo,
  DatePicker,
  DialogBody,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogHeaderContainer,
  DialogOverlay,
  DialogSubHeader,
  Dot,
  ExpandoOption,
  ExpansionMessage,
  ExpansionPanel,
  FieldWrapper,
  GMap,
  Goal,
  HorizontalRule,
  HtmlText,
  Icon,
  Image,
  Input,
  Label,
  Link,
  ListItem,
  Loader,
  LoaderInDialog,
  MailOrderPharmacyAddress,
  MemberAttachment,
  MessageHeader,
  PhoneLink,
  PhotoPreviewButton,
  PieChart,
  Pills,
  ProgressBar,
  Provider,
  Radio,
  Screen,
  Select,
  Text,
  TextField,
  Title,
  Description,
  Slider,
  Switch,
  Tabs,
  TaskList,
  TextArea,
  TimePicker,
  TimeSlotPicker,
  ToastBody,
  ToastCloseButton,
  ToastContainer,
  Tooltip,
  Spinner,
  WebImage,
  SelectWithChips,
  PhonePicker,
  ModernizedModalOverlay,
  ModernizedModalBody,
  ModernizedModalHeaderContainer,
  ModernizedModalHeader,
  ModernizedModalContent,
  ModernizedModalFooter,
  ModernizedDismissibleButton,
  ModernizedInlineMessage,
  ModernizedInputField,
  ModernizedLabel,
  ModernizedPhoneInput,
  ModernizedToggle,
  ModernizedAccordion,
  ModernizedIconButton
};
